<template>
  <div class="container">
    <div class="sale-tag"></div>
  </div>
</template>

<script>
export default {
  name: "SaleTag",
  data() {
    return {
      tagPosition: {
        top: 50, // موقعیت اولیه عمودی (پیکسل)
        left: 50, // موقعیت اولیه افقی (پیکسل)
      },
      isShaking: false,
    };
  },
  mounted() {
    this.startShaking();
  },
  methods: {
    startShaking() {
      this.isShaking = true;
      setInterval(() => {
        this.isShaking = !this.isShaking;
      }, 800); // انیمیشن هر 0.8 ثانیه تغییر می‌کند
    },
  },
};
</script>

<style scoped>
.sale-tag {
  position: absolute;
  transform-origin: top center;
  background: red;
  top: 0;
  clip-path: polygon(
    50% 0%,
    82.6% 11.1%,
    100% 39.6%,
    93.8% 81.9%,
    68.1% 100%,
    31.9% 100%,
    6.3% 81.9%,
    0% 39.6%,
    17.4% 11.1%
  );
}
</style>
